import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export const usePageTracking = () => {
  const location = useLocation();
  const startTime = useRef(Date.now());
  const prevPage = useRef(null);

  useEffect(() => {
    const currentPage = location.pathname;

    // Send duration for previous page
    if (prevPage.current && prevPage.current !== currentPage) {
      const duration = (Date.now() - startTime.current) / 1000;
      sendPageView(prevPage.current, duration);
    }

    // Reset for new page
    startTime.current = Date.now();
    prevPage.current = currentPage;

    // Track on unload
    const handleUnload = () => {
      const duration = (Date.now() - startTime.current) / 1000;
      const payload = JSON.stringify({
        page: currentPage,
        duration,
        referrer: document.referrer || null
      });
      const token = localStorage.getItem('token');
      const headers = { type: 'application/json' };
      const blob = new Blob([payload], headers);
      const url = `${API_URL}/api/page-analytics/track`;
      // sendBeacon for reliable delivery on page close
      if (navigator.sendBeacon) {
        // sendBeacon doesn't support custom headers, so we use fetch with keepalive
        fetch(url, {
          method: 'POST',
          body: payload,
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
          },
          keepalive: true
        }).catch(() => {});
      }
    };

    window.addEventListener('beforeunload', handleUnload);
    return () => window.removeEventListener('beforeunload', handleUnload);
  }, [location.pathname]);
};

function sendPageView(page, duration) {
  const token = localStorage.getItem('token');
  fetch(`${API_URL}/api/page-analytics/track`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {})
    },
    body: JSON.stringify({ page, duration, referrer: document.referrer || null }),
    keepalive: true
  }).catch(() => {});
}
